import Axios from "../../Config/API";
import Service from "../../Service";

export async function LogarUsuarioHelpDeskService() {
    return Service(
        Axios.get<{ message: string }>(
            `/helpdesk/userhelpdesk/loginusuariohelpdesk`
        )
    );
}

export async function DeslogarUsuarioHelpDeskService() {
    return Service(
        Axios.get<{ message: string }>(
            `/helpdesk/userhelpdesk/deslogarusuariohelpdek`
        )
    );
}
